export interface SvgIconProps {
  size?: number
  color?: string
  className?: string
  width?: number
  height?: number
}

export function ArrowDownTrayIcon({
  size = 18,
  color = 'currentColor',
  className
}: SvgIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      fill="none"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      stroke={color}
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {/* tray */}
      <path d="M3 16.5V19a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-2.5" />
      {/* arrow shaft */}
      <path d="M12 3v12" />
      {/* arrow head */}
      <path d="M7 10l5 5 5-5" />
    </svg>
  )
}
